import React, { useState, FormEvent } from 'react';
import {
  Container,
  Typography,
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  CardContent,
  Grid
} from '@mui/material';
import { WidgetType } from 'src/PageWidgetSection';
import GenericInput from '../../components/input-components/GenericTextInput';
import SelectInput from '@mui/material/Select/SelectInput';
import { IPageData, IPageState } from '../page';
import _, { add, constant, values } from 'lodash';
import { validateRepeatorField, validateSeoField } from '../validation';
import GenericSelectInput from 'src/components/input-components/GenericSelectInput';
import Repeater from 'src/components/repeater';
interface IAddPageItemProps {
  pageState: IPageState;
  onPageStateUpdate: (newState: IPageState) => void;
  submitting: boolean;
}

export const AddNewItemPage: React.FC<IAddPageItemProps> = ({
  onPageStateUpdate,
  pageState,
  submitting
}) => {
  const onFieldChange = (
    fieldName: keyof IPageState['values']['SEO'],
    value: any
  ) => {
    const newPageState = _.cloneDeep(pageState);
    newPageState.values.SEO[fieldName] = value;
    newPageState.touched.SEO[fieldName] = true;
    newPageState.errors.SEO[fieldName] = validateSeoField(fieldName, value);
    onPageStateUpdate(newPageState);
  };

  const onFieldBlur = (fieldName: keyof IPageState['values']['SEO']) => {
    const newPageState = _.cloneDeep(pageState);
    newPageState.touched.SEO[fieldName] = true;
    newPageState.errors.SEO[fieldName] = validateSeoField(
      fieldName,
      newPageState.values.SEO[fieldName]
    );
    onPageStateUpdate(newPageState);
  };

  const onRepeaterFieldChange = (index, value: any, feild) => {
    const newPageState = _.cloneDeep(pageState);

    newPageState.values.Items[index] = value;
    if (newPageState.touched.Items[index])
      newPageState.touched.Items[index] = {
        ...newPageState.touched.Items[index],
        [feild]: true
      };
    else {
      newPageState.touched.Items[index] = {
        [feild]: true
      };
    }
    onPageStateUpdate(newPageState);
    if (newPageState.errors.Items[index]) {
      newPageState.errors.Items[index][feild] = validateRepeatorField(
        feild,
        newPageState.values.Items[index],
        value[feild]
      );
    } else {
      newPageState.errors.Items[index] = {
        ...newPageState.errors.Items[index],
        [feild]: validateRepeatorField(
          feild,
          newPageState.values.Items[index],
          value[feild]
        )
      };
    }
  };

  const onRepeaterFieldBlur = (index, fieldName: string) => {
    const newPageState = _.cloneDeep(pageState);
    if (newPageState.touched.Items[index])
      newPageState.touched.Items[index] = {
        ...newPageState.touched.Items[index],
        [fieldName]: true
      };
    else
      newPageState.touched.Items[index] = {
        [fieldName]: true
      };
    onPageStateUpdate(newPageState);
  };

  // const validateForm = (pageState: IPageState) => {
  //   let isValid = true;

  //   const errorsItems: IPageState['errors']['Items'] =
  //     pageState.values.Items.map((item) => {
  //       const errors = {};
  //       errors['code'] = validateRepeatorField('code', item, item.code);
  //       errors['type'] = validateRepeatorField('type', item, item.code);

  //       if (item.type == WidgetType.ABOUT_TEXT) {
  //         errors['Title'] = validateRepeatorField('Title', item, item.Title);
  //         errors['Items'] = item.Items.map((item1) => {
  //           return {
  //             Heading: validateRepeatorField('Heading', item, item1.Heading),
  //             Description: validateRepeatorField(
  //               'Description',
  //               item,
  //               item1.Description
  //             )
  //           };
  //         });
  //       }
  //       // if (item.type == WidgetType.BANNER) {
  //       //   errors['imageUrl'] = validateRepeatorField(
  //       //     'imageUrl',
  //       //     item,
  //       //     item.imageUrl
  //       //   );
  //       // }
  //       // if (item.type == WidgetType.CHOOSE_US) {
  //       // }

  //       // if (item.type == WidgetType.CONTACT_FORM) {
  //       //   errors['Link'] = validateRepeatorField('Link', item, item.Link);
  //       //   errors['Title'] = validateRepeatorField('Title', item, item.Title);
  //       //   //Items later
  //       // }

  //       // if (item.type == WidgetType.FOOTER) {
  //       //   errors['DisclaimerSectionItems'] = item.DisclaimerSectionItems.map(
  //       //     (item1, index) => {
  //       //       return validateRepeatorField(
  //       //         'disclaimerSectionItem',
  //       //         item,
  //       //         item1
  //       //       );
  //       //     }
  //       //   );
  //       //   errors['Items'] = item.Items.map((item1) => {
  //       //     return {
  //       //       Link: validateRepeatorField('Link', item, item1.Link),
  //       //       Title: validateRepeatorField('Title', item, item1.Title)
  //       //     };
  //       //   });
  //       //   errors['socials'] = item.socials.map((item1) => {
  //       //     return {
  //       //       Image: validateRepeatorField('Image', item, item1.Image),
  //       //       Link: validateRepeatorField('Link', item, item1.Link)
  //       //     };
  //       //   });
  //       // }

  //       // if (item.type == WidgetType.HOME_BANNER) {
  //       //   errors['ImageUrl'] = validateRepeatorField(
  //       //     'mainImageUrl',
  //       //     item,
  //       //     item.ImageUrl
  //       //   );
  //       //   item.subtitle = validateRepeatorField(
  //       //     'subtitle',
  //       //     item,
  //       //     item.subtitle
  //       //   );
  //       //   item.Header = {
  //       //     MenuItems: item.Header.MenuItems.map((Item) => {
  //       //       return {
  //       //         Link: validateRepeatorField('Link', item, Item.Link),
  //       //         Text: validateRepeatorField('Text', item, Item.Text)
  //       //       };
  //       //     })
  //       //   };
  //       //   item.content = {
  //       //     Items: item.content.Items.map((Item) => {
  //       //       return {
  //       //         imageUrl: validateRepeatorField('imageUrl', item, Item.imageUrl)
  //       //       };
  //       //     }),
  //       //     Heading: validateRepeatorField(
  //       //       'Heading',
  //       //       item,
  //       //       item.content.Heading
  //       //     )
  //       //   };
  //       // }

  //       if (item.type == WidgetType.IMAGE_LIST_VIEW) {
  //         item.Items.map((Item) => {
  //           return {
  //             Title: validateRepeatorField('Title', item, Item.Title),
  //             width: validateRepeatorField('Title', item, Item.Title),
  //             height: validateRepeatorField('Title', item, Item.Title),
  //             ImageUrl: validateRepeatorField('Title', item, Item.Title)
  //           };
  //         });
  //       }

  //       if (item.type == WidgetType.JOB_OPPENING) {
  //         return {
  //           Items: item.Items.map((Item) => {
  //             return {
  //               Title: validateRepeatorField('Title', item, Item.Title),
  //               Type: validateRepeatorField('Type', item, Item.Type),
  //               Loaction: validateRepeatorField(
  //                 'Location',
  //                 item,
  //                 Item.Location
  //               ),
  //               Salary: validateRepeatorField('Salary', item, Item.Salary),
  //               Description: validateRepeatorField('Description', item, Item.Description)
  //             };
  //           })
  //         };
  //       }

  //       if (item.type == WidgetType.LEADERSHIP) {
  //         return {
  //           Title: validateRepeatorField('title', item, item.Title),
  //           Items: item.Items.map((Item) => {
  //             return {
  //               ImageUrl: validateRepeatorField(
  //                 'ImageUrl',
  //                 item,
  //                 Item.ImageUrl
  //               ),
  //               Heading: validateRepeatorField('Heading', item, Item.Heading),
  //               Subtitle: validateRepeatorField(
  //                 'Subtitle',
  //                 item,
  //                 Item.Subtitle
  //               ),
  //               Description: validateRepeatorField(
  //                 'Description',
  //                 item,
  //                 Item.Description
  //               )
  //             };
  //           })
  //         };
  //       }

  //       if (item.type == WidgetType.LISTING_SECTION) {
  //         return {
  //           Items: item.Items.map((Item) => {
  //             return {
  //               Title: validateRepeatorField('Title', item, Item.Title),
  //               Link: validateRepeatorField('Link', item, Item.Link),
  //               LinkTitle: validateRepeatorField(
  //                 'LinkTitle',
  //                 item,
  //                 Item.LinkTitle
  //               )
  //             };
  //           })
  //         };
  //       }

  //       // if (item.type == WidgetType.QA) {
  //       //   return {
  //       //     Items: item.Items.map((Item) => {
  //       //       return {
  //       //         Title: validateRepeatorField('Title', item, Item.Title),
  //       //         Link: validateRepeatorField('Link', item, Item.Link),
  //       //         LinkTitle: validateRepeatorField(
  //       //           'LinkTitle',
  //       //           item,
  //       //           Item.LinkTitle
  //       //         )
  //       //       };
  //       //     })
  //       //   };
  //       // }

  //       // if (item.type == WidgetType.TIME_LINE) {
  //       //   return {
  //       //     Title: validateRepeatorField('Title', item, item.Title),
  //       //     Items: item.Items.map((Item) => {
  //       //       return {
  //       //         Description: validateRepeatorField(
  //       //           'Description',
  //       //           item,
  //       //           Item.Description
  //       //         ),
  //       //         Heading: validateRepeatorField('Heading', item, Item.Heading)
  //       //       };
  //       //     })
  //       //   };
  //       // }

        
  //       if (item.type == WidgetType.QUESTION_ANSWER) {
  //         return {
  //           Title: validateRepeatorField('answer', item, item.Title),
  //           Items: item.Items.map((Item) => {
  //             return {
  //               Title: validateRepeatorField('Title', item, Item.Title),
  //               Items: Item.Items.map((item1) => {
  //                 return {
  //                   Description: validateRepeatorField(
  //                     'Description',
  //                     item,
  //                     item1.Description
  //                   )
  //                 };
  //               })
  //             };
  //           })
  //         };
  //       }
  //       if (item.type == WidgetType.VALUED_CLIENTS) {
  //         return {
  //           Title: validateRepeatorField('Title', item, item.Title),
  //           Description: validateRepeatorField(
  //             'Description',
  //             item,
  //             item.Description
  //           ),

  //           Items: item.Items.map((Item) => {
  //             return {
  //               ImageURL: validateRepeatorField('ImageURL', item, Item.ImageURL)
  //             };
  //           })
  //         };
  //       }
  //       return errors;
  //     });

  //   let errors: IPageState['errors'] = {
  //     SEO: {
  //       Title: validateSeoField('Title', pageState.values.SEO.Title),
  //       Description: validateSeoField(
  //         'Description',
  //         pageState.values.SEO.Description
  //       ),
  //       Keywords: validateSeoField('Keywords', pageState.values.SEO.Keywords),
  //       Code: ''
  //     },
  //     Items: errorsItems
  //   };

  //   let touched: IPageState['touched'] = {
  //     SEO: {
  //       Title: true,
  //       Description: true,
  //       Keywords: true,
  //       Code: true
  //     },
  //     Items: [{}]
  //   };

  //   return { errors, touched, isValid };
  // };

  const addItem = () => {
    event.preventDefault();
    const newPageState = _.cloneDeep(pageState);
    newPageState.values.Items = [
      ...newPageState.values.Items,
      { code: '', type: undefined } as any
    ];
    onPageStateUpdate(newPageState);
  };

  // Delete an item based on its index.
  const deleteItem = (index: number) => {
    event.preventDefault();
    const newPageState = _.cloneDeep(pageState);
    newPageState.values.Items = newPageState.values.Items.filter(
      (_, i) => i !== index
    );
    onPageStateUpdate(newPageState);
  };

  const onSubmit = () => {
    const newPageState = _.cloneDeep(pageState);

    // const { errors, touched } = validateForm(newPageState);
    // newPageState.errors = errors;
    // newPageState.touched = touched;
    onPageStateUpdate(newPageState);
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Card elevation={6} sx={{ p: 2 }}>
            <CardContent>
              <Typography
                variant="h5"
                gutterBottom
                sx={{ fontWeight: 'bold', mb: 2 }}
              >
                SEO Section
              </Typography>

              <Grid container spacing={2}>
                {/* Title */}
                <Grid item xs={12} sm={6}>
                  <GenericInput
                    type="text"
                    name="Title"
                    title="Title"
                    value={pageState.values.SEO.Title}
                    onChange={(val) => onFieldChange('Title', val)}
                    onBlur={() => onFieldBlur('Title')}
                    error={pageState.errors.SEO.Title}
                    disabled={submitting}
                  />
                </Grid>

                {/* Keywords */}
                <Grid item xs={12} sm={6}>
                  <GenericInput
                    type="text"
                    name="Keywords"
                    title="Keywords"
                    value={pageState.values.SEO.Keywords}
                    onChange={(val) => onFieldChange('Keywords', val)}
                    onBlur={() => onFieldBlur('Keywords')}
                    disabled={submitting}
                  />
                </Grid>

                {/* Route */}
                <Grid item xs={12}>
                  <GenericInput
                    type="text"
                    name="Code"
                    title="Route"
                    value={pageState.values.SEO.Code}
                    onChange={(val) => onFieldChange('Code', val)}
                    error={pageState.errors.SEO.Code}
                    onBlur={() => onFieldBlur('Code')}
                    disabled={submitting}
                  />
                </Grid>

                {/* Description (Full Width) */}
                <Grid item xs={12}>
                  <GenericInput
                    type="text"
                    name="Description"
                    title="Description"
                    value={pageState.values.SEO.Description}
                    onChange={(val) => onFieldChange('Description', val)}
                    onBlur={() => onFieldBlur('Description')}
                    disabled={submitting}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
      </Container>

      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Card>
          <CardContent>
            <Box
              component="form"
              onSubmit={() => {}}
              sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}
            >
              <Typography variant="h5" gutterBottom>
                Widgets Section
              </Typography>
              <Repeater
                items={pageState.values.Items}
                errors={pageState.errors.Items}
                addItem={addItem}
                deleteItem={deleteItem}
                updateItem={onRepeaterFieldChange}
                blurItem={onRepeaterFieldBlur}
              />
            </Box>
            {/* <button onClick={onSubmit}>Click Me</button> */}
          </CardContent>
        </Card>
      </Container>
    </>
  );
};
